import React from 'react';
import useStyle from './pedagogicalChallengesButton.style';
import { classNames } from 'helpers/style/classNames';
import { formatDate } from 'helpers/date/formatDate';

export interface PedagogicalChallengesButtonProps {
  variant: 'default' | 'finished';
  name: string;
  startDate: string;
  endDate: string;
  onClick?: () => void;
}

export const PedagogicalChallengesButton = ({
  variant,
  name,
  startDate,
  endDate,
  onClick
}: PedagogicalChallengesButtonProps) => {
  const classes = useStyle();

  return (
    <button
      className={classNames([classes.root, classes[variant]])}
      onClick={onClick && onClick}
    >
      <span>{name}</span>
      {variant !== 'finished' && (
        <span className={classes.date}>{`${startDate &&
          formatDate(startDate)} - ${endDate && formatDate(endDate)}`}</span>
      )}
    </button>
  );
};
